import { render } from "./GroupCard.vue?vue&type=template&id=3ff2d50e"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"

import "./GroupCard.vue?vue&type=style&index=0&id=3ff2d50e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QExpansionItem,QList,QItem,QSeparator,QCardActions,QIcon,QBtn});
